export const matchStatus = (status) => {
  if (status === 'open') return 'Aberto';
  if (status === 'answered') return 'Respondido';
  return 'Encerrado';
};

export const matchFeedbackType = (type) => {
  switch (type) {
    case 'question':
      return 'Pergunta';
    case 'sugestion':
      return 'Sugestão';
    case 'bug':
      return 'Bug';
    default:
      return 'Outros';
  }
};

export const matchPriority = (priority) => {
  switch (priority) {
    case 'low':
      return 'Baixa';
    case 'medium':
      return 'Média';
    default:
      return 'Alta';
  }
};

export const getFormatedDate = (date) => {
  const substring = date.substring(0, 10);
  const [year, month, day] = substring.split('-');
  return `${day}/${month}/${year}`;
};

export const formatDateTime = (isoString) => {
  const date = new Date(isoString);

  const formattedDate = date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const formattedTime = date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  return `${formattedDate} às ${formattedTime}hs`;
};

export const bytesToMegabytes = (bytes) => (bytes / (1024 * 1024)).toFixed(2);
